import axios, { getEnv } from "../../../services/api";

export const EventoSebraeService = {
    
    findAll: async (params, body = {}, source) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/evento-sebrae`, body);
            return response.data;
        } catch (error) {
            console.log(error.message);
            throw error;
        }
    },
    
    find: async (idEvento) => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/evento-sebrae/${idEvento}`)
            return response.data;
        } catch (error) {
            return error;
        }
    },
    
    save: async (body) => {
        const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/evento-sebrae`, body);
        return response.data;
        
    },
    
    update: async (body) => {
        return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/evento-sebrae`, body);
    },
    
    delete: async (idEvento) => {
        try {
            return await axios.delete(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/evento-sebrae/${idEvento}`);
        } catch (error) {
            return error;
        }
    },
}

